import classNames from 'classnames'

import type { ImageProps } from '~/components/atoms/Image/Image'
import ImageRelative from '~/components/report/components/ImageRelative/ImageRelative'
import { useMediaQuery } from '~/services/useMediaQuery'

import type { IMagazineAdvert } from '../MagazineAdvert/MagazineAdvert'
import MagazineAdvert from '../MagazineAdvert/MagazineAdvert'

import styles from './Advert.module.css'

export interface AdvertProps extends IMagazineAdvert {
  image: ImageProps
  landscapeImage: ImageProps
  link: string
  useContainer?: boolean
}

export default function Advert({
  image,
  landscapeImage,
  link,
  useContainer = false,
  title,
  introduction,
  modalImage,
}: AdvertProps) {
  const isMobile = useMediaQuery(`(max-width: 1162px)`)

  if (!isMobile && !landscapeImage) {
    return null
  }

  const renderItem = () => {
    return (
      <div
        className={classNames(
          styles.magazineAdvertContainer,
          !useContainer && styles.noPadding
        )}
      >
        <div className={styles.advertInner}>
          <div className={classNames(styles.magazineAdvert)}>
            <MagazineAdvert
              title={title}
              modalImage={modalImage}
              link={link}
              introduction={introduction}
            >
              <ImageRelative
                image={!isMobile ? image : landscapeImage}
                marginBottom={false}
              />
            </MagazineAdvert>
          </div>
        </div>
      </div>
    )
  }

  return renderItem()
}
